export default class Article {
  constructor(elem, _) {
    this.elem = elem;
    this.shareUrl = this.elem.querySelectorAll(".js-article-share-url");
  }

  copyToClipboard() {
    if (!this.shareUrl[0] || !this.shareUrl[0].dataset.url) {
      return;
    }

    const url = this.shareUrl[0].dataset.url;
    navigator.clipboard.writeText(url).then(() => {
      const shareTooltip = this.elem.querySelectorAll('.share-tooltip');
      shareTooltip.forEach(tooltip => {
        tooltip.classList.add('active');
      });

      setTimeout(() => {
        shareTooltip.forEach(tooltip => {
          tooltip.classList.remove('active');
        });
      }, 1200);
    });
  }

  // Count columns in each table and set data-columns attribute on parent .custom-table-wrapper
  setTableColumnCounts() {
    const tables = this.elem.querySelectorAll('table');
    tables.forEach(table => {
      const firstRow = table.querySelector('tr');
      if (firstRow) {
        const columns = firstRow.querySelectorAll('th, td').length;
        const wrapper = table.closest('.custom-table-wrapper');
        const scrollableSize = columns > 6 ? 'scrollable-lg' : columns > 5 ? 'scrollable-md' : columns > 3 ? 'scrollable-sm' : '';
        if (wrapper) {
          wrapper.setAttribute('data-columns', columns);
          if (scrollableSize) {
            wrapper.classList.add(scrollableSize);
          }
        }
      }
    });
  }

  init() {
    if (this.shareUrl[0]) {
      this.shareUrl.forEach(shareUrl => {
        shareUrl.addEventListener("click", this.copyToClipboard.bind(this));
      });
    }

    this.setTableColumnCounts();
  }
};
